import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'li' | 'section';
};
export function Reveal({
  children,
  className = '',
  delay = 0
}: Props) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.4,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-300" data-mp="yf9s614rkfi2">
      {children}
    </motion.div>;
}